// Order-carrying responses can resolve out of order under rapid edits: a slow
// response initiated before the last committed one would silently reinstate
// stale order state. Each request is stamped at initiation and older responses
// are dropped instead of committed. Every commit of a whole-order payload must
// go through this guard, including ones made outside the Vuex module.
let requestSequence = 0;
let committedSequence = 0;
let keptLines = null;

export const beginOrderRequest = () => ++requestSequence;

export const commitOrderIfCurrent = (commit, sequence, order, mutation = "replaceOrder") => {
  // Not strictly older: invalidation outdates every request issued so far by
  // marking the newest as committed, and a strict test would let that one
  // through — the very response most likely to still be in flight.
  if (sequence <= committedSequence) {
    console.warn("Discarded a stale order response that resolved after a newer update.");
    return;
  }
  committedSequence = sequence;
  const readBeforeLines = keptLines && sequence <= keptLines.through && order?.id === keptLines.orderId;
  commit(mutation, readBeforeLines ? { ...order, transporters: keptLines.lines } : order);
};

// Transporter lines save on their own. A response to a request issued before
// the latest line change still commits, but keeps the current lines.
export const keepTransporterLines = (orderId, lines) => {
  keptLines = { orderId, lines, through: requestSequence };
};

// Deliberately clearing the order also outdates every in-flight response, so
// none of them can resurrect it.
export const invalidateInFlightOrderRequests = () => {
  committedSequence = requestSequence;
};
